export default {"src":"/_next/static/media/sign-back-in-icon.38d15971.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};